<template>
  <!-- 发现搜索页面 -->
  <div class="discover_search">
    <van-sticky>
      <van-search
        shape="round"
        background="#fff"
        v-model="searchValue"
        :show-action="showAction"
        placeholder="搜索问问动态/作者"
        @search="onSearch"
        @cancel="onCancel"
      >
      <template #right-icon>
        <div @click="onSearch" class="search_btn_right">搜索</div>
      </template>
      </van-search>
      <div class="w_title" v-if="isShow">
        <div class="w80">
          <div class="discover" @click="changeTab('discover')">
            <span :class="{'active':active=='discover'}">内容</span>
          </div>
          <div class="bees"  @click="changeTab('bees')">
            <span :class="{'active':active=='bees'}">蜜蜂</span>
          </div>
        </div>
        <div class="screen" @click="showScreen=!showScreen">筛选<van-icon name="filter-o" /></div>
        <!-- <div class="w80">
          <van-tabs
        v-model="active"
        color="#F8D541"
        line-width="30px"
        :border="false"
        @change="changeTab"
      >
        <van-tab title="内容" name="discover"></van-tab>
        <van-tab title="蜜蜂" name="bees"></van-tab>
        </van-tabs>
        </div>
        <div class="screen" @click="showScreen=!showScreen">筛选<van-icon name="filter-o" /></div> --> -->
      </div>
    </van-sticky>
    <div class="tabs-content-warp" v-if="isShow">
      <div class="cotent_warp">
        <div class="search_content" v-if="list.length>0 && active==='discover'">
          <Waterfall
            :minCol="2"
            :maxCol="2"
            :percent="[1,1]"
            :gutterHeight="10"
            :width="itemWidth"
            :gutterWidth="gutterWidth"
          >
            <itemContent
              v-for="(item,index) in list"
              :key="index"
              :item="item"
              :likeCount="item.likeCount"
              :like="item.isLike==='y'?true:false"
            />
          </Waterfall>
        </div>
        <div v-else-if="bees.length>0 && active==='bees'">
          <beeItem v-for="(item,index) in bees" :key="index" :item="item" />
        </div>
        <div v-else>
          <emptyItem info="暂没有找到内容，换个词在搜一遍吧！" />
        </div>
      </div>
    </div>
    <van-popup
      v-model="showScreen"
      position="right"
      round
      :style="{ height: '100%',width:'85%' }"
      get-container="#app"
      class="screen_search"
    >
      <div class="title"><p>品类筛选</p></div>
      <div class="content">
        <van-collapse v-model="activeName" accordion :border="false">
          <van-collapse-item
            :title="item.categoryName"
            :name="index"
            value="更多"
            v-for="(item,index) in screenList"
            :key="index"
          >
            <div class="screen_btndiv">
              <span
                class="van-ellipsis"
                v-for="(i,idx) in item.childrenCategoryList"
                :key="idx"
                @click="pushCategoryIds(i)"
                :class="{'active':categoryLevelId3.includes(i.categoryId)}"
              >{{i.categoryName}}</span>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="footer">
        <van-button plain hairline type="primary" size="small" color="#999999" round @click="resetids">重置</van-button>
        <van-button  hairline type="success" size="small" color="#F8D541" round @click="submit">确定</van-button>
      </div>
    </van-popup>
    <historyItem v-show="!isShow" @changeVal="changeVal" />
  </div>
</template>
<script>
import historyItem from "./components/historyItem";
import beeInfo from "./components/beeInfo";
import beeItem from "./components/beeItem";
import emptyItem from "./components/emptyItem";
import searchTitle from "./components/searchTitle";
import { Waterfall } from "vue2-waterfall";
import itemContent from "./components/itemContent";
import http from "@/utils/axios";
import utils from "@/utils/common";
export default {
  data() {
    return {
      activeName: "0",
      searchValue: "",
      isShow: false,
      showScreen: false,
      active: "discover",
      list: [],
      categoryLevelId3: [],
      bees: [],
      screenList: [],
      pageIndex: 1,
      showAction: true
    };
  },
  methods: {
    onSearch() {
      if (this.searchValue.trim()) {
        this.isShow = true;
        if (
          !this.$store.getters.getDiscoverHistory.includes(this.searchValue)
        ) {
          this.$store.dispatch("setDiscoverHistory", this.searchValue);
        }
        this.getData();
      }
    },
    changeVal(val) {
      this.searchValue = val;
      this.onSearch();
    },
    onCancel() {
      if (window.tools.isWechat()) {
        this.$router.go(-1);
      } else {
        utils.goBack();
      }
      console.log(1);
      this.isShow = false;
    },
    changeTab(item) {
      this.active = item;
      if (this.searchValue.trim()) {
        this.getData();
      }
    },
    getData() {
      this.$loading.show();
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: 20,
        searchWord: this.searchValue,
        type: this.active
      };
      if (this.categoryLevelId3.length > 0) {
        parmes.categoryLevelId3 = this.categoryLevelId3;
      }
      http({
        url: "/discover/appuser/beesdiscover/search",
        method: "post",
        parmes: parmes
      }).then(rps => {
        if (rps.code == 200) {
          if (this.active == "bees") {
            this.bees = rps.data.list;
          } else {
            this.list = rps.data.list;
          }
        }
        this.$loading.hide();
      });
    },
    // 获取分类
    getScreenData() {
      this.$loading.hide();
      http({
        url: "/discover/appbees/discover/content/screenList",
        method: "POST"
      }).then(rps => {
        if (rps.code === 200) {
          this.screenList = rps.data;
        }
      });
    },
    pushCategoryIds(item) {
      if (this.categoryLevelId3.includes(item.categoryId)) {
        this.categoryLevelId3.splice(this.categoryLevelId3.indexOf(item.categoryId),1);
      } else {
        this.categoryLevelId3.push(item.categoryId);
      }
    },
    resetids(){
      this.categoryLevelId3=[];
      this.getData();
    },
    submit(){
      if(this.categoryLevelId3.length>0){
        this.showScreen =!this.showScreen;
        this.getData();
      }
    }
  },
  computed: {
    itemWidth() {
      return 133 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 10 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  },
  components: {
    historyItem,
    beeInfo,
    beeItem,
    emptyItem,
    searchTitle,
    itemContent,
    Waterfall
  },
  created() {
    this.getScreenData();
    if (window.tools.isWechat()) {
      this.showAction = false;
    }
    console.log(this.$route.query);
    if (this.$route.query.parmes) {
      this.searchValue = this.$route.query.parmes;
      this.onSearch();
    }
    utils.nativeMethod({tm:'4000102',tp:{pageType_pvar:'发现模块'}})
    utils.nativeMethod({tm:'4000102',tp:{pageName_pvar:document.title}})
  }
};
</script>
<style lang="less" scoped>
.discover_search {
   .search_btn_right{
    background-color: #F8D541;
    color: #333;
    font-size: 24px;
    box-sizing: border-box;
    width: 100px;
    text-align: center;
    border-radius: 32px;

  }
  .search_content {
    padding: 20px;
  }
  .w_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    position: relative;
    .w80{
      
      width: 100%;
      font-size: 28px;
      font-weight: 500;
      div{
        width: calc(100% /2);
        display: inline-block;
        padding: 20px 80px;
        box-sizing: border-box;
      }
      .discover{
        text-align: right;
      }
      .active{
        position: relative;
        font-weight: bold;
        &::after{
          content: ' ';
          position: absolute;
          width: 56px;
          bottom: -15px;
          height: 6px;
          background: #F8D541;
          left: 1px;
          border-radius: 6px;
        }
      }
    }
    // .w80{
    //   flex: 1;
    // }
    .screen {
    width: 80px;
    position: absolute;
    right: 0;
    background-color: #fff;
    text-align: right;
    font-size: 26px;
    color: #333;
    height: auto;
    padding: 20px 30px;
  }
  }
}
.screen_search {
  font-size: 20px;
  .title {
    text-align: center;
    position: relative;
    padding:96px 30px 46px 30px;
     font-size: 28px;
    box-sizing: border-box;
    p{
      font-size:32px;
      color: #333;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
    }
  }
  .content {
    height: 75vh;
    overflow: scroll;
    .screen_btndiv {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      span {
        background-color: #fff;
        border-radius: 32px;
        border: 1PX solid #999;
        display: inline-block;
        color: #999;
        font-size: 24px;
        text-align: center;
        padding: 10px 0;
        margin: 10px;
        box-sizing: border-box;
        width: 170px;
        &.active {
          color: #333;
          background-color: #F8D541;
           border: 1PX solid #F8D541;
        }
      }
    }
  }
  .footer {
    padding: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    button{
      width: 245px;
    }
    .van-button--success {
      .van-button__text{
        color: #333;
      }
    }
  }
}
</style>